import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/pages/login/Login.vue';
import Home from '@/components/pages/home/Home.vue';
import Clientes from '@/components/pages/cadastro/cliente/Clientes.vue';
import NovoCliente from '@/components/pages/cadastro/cliente/NovoCliente.vue';
import ListaClientes from '@/components/pages/cadastro/cliente/ListaClientes.vue';
import EditarCliente from '@/components/pages/cadastro/cliente/EditarCliente.vue';
import SolicitarTrocarSenha from '@/components/pages/login/SolicitarTrocarSenha.vue';
import ValidarCodigoToken from '@/components/pages/login/ValidarCodigoToken.vue';
import TrocarSenha from '@/components/pages/login/TrocarSenha.vue';
import MeusDados from '@/components/pages/usuario/MeusDados.vue';
import { CHVAE_TOKEN } from '@/global';

import store from '@/plugins/store/store';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Home,
			meta: {
				loginRequerido: true,
				permissao: 0				
			},
			children: [
				{
					path: '/cadastro/clientes',
					component: Clientes,
					meta: {
						loginRequerido: true,
					},
					children: [
						{path: '', component: ListaClientes, meta: {loginRequerido: true}},
						{path: 'novo', component: NovoCliente, meta: {loginRequerido: true}},
						{path: ':id/editar', component: EditarCliente, props: true, meta: {loginRequerido: true}}
					]
				},
				{
					path: '/conta/meus-dados',
					component: MeusDados,
					meta: {
						loginRequerido: true,
					},					
				},				
			]        
		},		
		{			
			path: '/login',
			component: Login,
			meta: {
				loginRequerido: false,				
			}             
		},
		{			
			path: '/esqueci-senha',
			component: SolicitarTrocarSenha,
			meta: {
				loginRequerido: false,				
			}             
		},	
		{			
			path: '/redefinir-senha',
			component: TrocarSenha,
			meta: {
				loginRequerido: false,				
			}             
		},
		{			
			path: '/validar-codigo-senha',
			component: ValidarCodigoToken,
			meta: {
				loginRequerido: false,				
			}             
		},	
	],
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});

router.beforeEach((to, from, next) => {
	let isAutenticado = store.getters['sessao/getIsAutenticado'];
	let token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN)); 
	if(to.matched.some(record => record.meta.loginRequerido)) {	
		if(!isAutenticado || !token) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			});	
		} else {
			next();
		}
	} else if(isAutenticado && to.path == '/login') {	
		next('/');
	} else {	
		next();
	}
});

export default router;
